<template>
    <div>
        <a :href="data.href"
            v-if="data.slug"
            @click.stop>
            <strong class="subcategory-title"> {{ data.libelle }} </strong>
        </a>

        <strong v-if="!data.slug" class="subcategory-title">{{ data.libelle }}</strong>
    </div>
</template>

<script>

export default {

    props: {

        data: {
            type: Object,
            required: true
        },

    }
    
}

</script>
